
  import userController from '/home/builduser/work/fd01d09c8ef7e246/packages/ecom-platform-cart-icon/src/components/CartIcon/controller.ts';
  import createControllerWrapper from '@wix/yoshi-flow-editor/runtime/esm/controllerWrapper.js';

  
const wrapController = null;


  
var createHttpClient = null;

  

  import { initI18nWithoutICU as initI18n } from '@wix/yoshi-flow-editor/runtime/esm/i18next/init';


  
const multilingualDisabled = false;

  

    var createExperiments = null;
    var createWidgetExperiments = null;
    


  var sentryConfig = {
    DSN: 'https://a15b644ebf243f0edfda94c3b7cdaf66@o37417.ingest.us.sentry.io/4510261235482624',
    id: '4510261235482624',
    projectName: 'ecom-platform-cart-icon',
    teamName: 'shoplifters',
    errorMonitor: true,
  };

  var experimentsConfig = {"scopes":["stores","viewer-apps-1380b703-ce81-ff05-f115-39571d94dfcd"],"centralized":true};

  var translationsConfig = {"icuEnabled":false,"defaultTranslationsPath":"/home/builduser/work/fd01d09c8ef7e246/packages/ecom-platform-cart-icon/src/assets/locales/messages_en.json","availableLanguages":["ar","bg","ca","cs","da","de","el","en","es","fi","fr","he","hi","hr","hu","id","it","ja","ko","lt","lv","ms","nl","no","pl","pt","ro","ru","sk","sl","sv","th","tl","tr","uk","vi","zh"]};

  var biConfig = null;

  var defaultTranslations = {"CART_ICON_7":"Cart","shoppingCartIcon.designTab.cartIconStyle.iconTextLabel":"Icon text","sr.CART_WIDGET_BUTTON_TEXT":"Cart with {{itemsCount}} items","shoppingCartIcon.widgetTitle":"Cart Icon","shoppingCartIcon.designTab.cartIconStyle.iconTextPlaceholder":"Cart","CART_ICON_3":"CART","CART_ICON_4":"Cart","CART_ICON_5":"Cart"};

  var fedopsConfig = null;

  import { createVisitorBILogger as biLogger } from '/home/builduser/work/fd01d09c8ef7e246/packages/ecom-platform-cart-icon/target/generated/bi/createBILogger.ts';

  const controllerOptions = {
    sentryConfig,
    biConfig,
    fedopsConfig,
    experimentsConfig,
    biLogger,
    translationsConfig,
    persistentAcrossPages: false,
    appName: "CART ICON OOI",
    componentName: "CartIcon",
    appDefinitionId: "1380b703-ce81-ff05-f115-39571d94dfcd",
    componentId: "1380bbc4-1485-9d44-4616-92e36b1ead6b",
    projectName: "ecom-platform-cart-icon",
    defaultTranslations,
    multilingualDisabled,
    shouldUseEssentials: true,
    withErrorBoundary: false,
    localeDistPath: "assets/locales"
  };

  const _controller = createControllerWrapper(userController, controllerOptions, {
    initI18n,
    createHttpClient,
    createExperiments,
  });

  export const wrap = wrapController;
  export const descriptor = {
    ...controllerOptions,
    id: controllerOptions.componentId,
    widgetType: "WIDGET_OUT_OF_IFRAME",
    controllerFileName: "/home/builduser/work/fd01d09c8ef7e246/packages/ecom-platform-cart-icon/src/components/CartIcon/controller.ts",
  };

  export const controller = _controller
  export default controller;
